import { merge } from "lodash-es"
import {
  PRIVATE_DOCUMENT_DESER,
  PrivateDocument,
  type ItemsResponse,
  type PaginationParams,
} from "../../tastyworks"
import type HttpClient from "../../tastyworks/http"

export interface TaxDocumentParams extends PaginationParams {
  taxYear: number
}

export class TaxDocumentService {
  constructor(private readonly accountNumberClient: HttpClient) {
    this.accountNumberClient = accountNumberClient.nested("documents")
  }

  readonly index = async (
    accountNumber: string,
    params?: TaxDocumentParams
  ): Promise<ItemsResponse<PrivateDocument>> =>
    this.accountNumberClient.indexSimple(
      PRIVATE_DOCUMENT_DESER.toParser(PrivateDocument),
      "/taxes",
      merge({ accountNumber }, params)
    )
}
